import { Route, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'

import { Box, Dialog, Icon, Heading, LoadingPlane } from '@redriverpress/system'

import VideoGenreCategoriesDefault from './VideoGenreCategoriesDefault'
import NavModalTrigger from '../../../common/components/NavModalTrigger'
import useGenres from '../../hooks/useVideoGenres'

import {
  Content,
  GenreLink,
  TitleBar,
} from '../../../common/components/defaultCommon'
import { GENRE_AND_CATEGORY_PATH, GENRE_PATH } from '../../constants/routes'

export default function GenresDefault() {
  const { isLoading, genres, activeGenre } = useGenres()

  const [dialogOpen, setDialogOpen] = useState(false)

  const { pathname } = useLocation()

  useEffect(() => {
    // Close Genres dialog when location path changes (result of selecting a GenreLink)
    dialogOpen && setDialogOpen(false)
  }, [pathname])

  return isLoading ? (
    <Box textAlign='center'>
      <LoadingPlane />
    </Box>
  ) : (
    <Box mb={3}>
      <Dialog.Root
        open={dialogOpen}
        onOpenChange={isOpen => setDialogOpen(isOpen)}
      >
        <Box mb={2}>
          <Dialog.Trigger asChild>
            <NavModalTrigger label={activeGenre?.title} />
          </Dialog.Trigger>
        </Box>

        <Dialog.Portal>
          <Dialog.Overlay />

          <Content>
            <nav>
              <TitleBar>
                <Box flex={1}>
                  <Dialog.Title asChild>
                    <Heading as='h6' mb={0}>
                      Sections
                    </Heading>
                  </Dialog.Title>
                </Box>
                <Dialog.Close />
              </TitleBar>
              {/* pt: 5rem to clear title box */}
              <Box pt='5rem' pb={3} px={3}>
                {genres.map(genre => (
                  <GenreLink
                    key={genre.id}
                    exact={genre.slug === ''}
                    to={`/videos/${genre.slug}`}
                    isActive={(match, location) =>
                      !!match && location.search === ''
                    }
                  >
                    <Box pt={1} flex={1} display='flex' alignItems='baseline'>
                      {genre.title}
                      <Icon data-active-genre-icon icon='check' ml='auto' />
                    </Box>
                  </GenreLink>
                ))}
              </Box>
            </nav>
          </Content>
        </Dialog.Portal>
      </Dialog.Root>

      <Route path={[GENRE_AND_CATEGORY_PATH, GENRE_PATH]}>
        <VideoGenreCategoriesDefault />
      </Route>
    </Box>
  )
}
